// Copyright (c) 2022 by Move Closer

import { ComponentInternalInstance, computed, PropType, toRef } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../vue-api'
import { useThemeClass } from '../../composables'

import { ListOrientation, ListStyle, ListProps, UseListProvides, ListElement } from './List.contracts'
import { orientationClassRegistry, pointerClassRegistry } from './List.config'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const listProps: ComponentObjectPropsOptions<ListProps> = {
  elementClass: {
    type: [String, Array, Object],
    required: false
  },

  elements: {
    type: Array as PropType<ListElement[]>,
    required: true,
    default: () => ([])
  },

  listStyle: {
    type: String as PropType<ListStyle>,
    required: false,
    default: () => ListStyle.NoPointer
  },

  orientation: {
    type: String as PropType<ListOrientation>,
    required: false,
    default: () => ListOrientation.Vertical
  }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const useList = (props: ListProps, internalInstance: ComponentInternalInstance | null): UseListProvides => {
  if (internalInstance === null) {
    throw new Error('useList(): FATAL ERROR! Failed to resolve the component instance!')
  }

  const { type } = internalInstance
  const tag = computed<string>(() => props.listStyle === ListStyle.Ordered ? 'ol' : 'ul')

  const { themeClass: orientationClass } = useThemeClass(
    toRef(props, 'orientation'),
    orientationClassRegistry,
    `${type._componentTag}`,
    false
  )

  const { themeClass: pointerClass } = useThemeClass(
    toRef(props, 'listStyle'),
    pointerClassRegistry,
    `${type._componentTag}`,
    false
  )

  return { orientationClass, pointerClass, tag }
}
